import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";
import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../app/slices/TrainingSlice";
import { IDynamicInteraction } from "../../models/interactions/DynamicInteraction";
import PiPopupHeaderBar from "../previews/components/PiPopupHeaderBar";
import DynamicInteractionPreviewBody from "./DynamicInteractionPreviewBody";
import usePropHelper from "../../hooks/PropHelper";
import { useMemo } from "react";
export default function DynamicInteractionPreview() {
  const { getPropPresetByInstanceId } = usePropHelper();
  const interaction = useSelector(selectSelectedElement) as IDynamicInteraction;

  const source = useMemo(() => {
    return getPropPresetByInstanceId(interaction.source);
  }, [interaction.source]);

  // the prop that defines this interaction, on the right like a conversation's cast
  const header = (
    <PiPopupHeaderBar
      interactionType={interaction.type}
      title={interaction.name}
      trailing={source?.name && <span className="text-[14px] text-creator-text-sub">{source.name}</span>}
    />
  );

  return (
    <PiPopupWindowPreview
      body={<DynamicInteractionPreviewBody />}
      header={header}
    />
  );
}
